
import {mapActions, mapGetters} from 'vuex'
import ThemesMixins from './Themes'
export default {
    data(){
        return {
            config:null
        }
    },

    mixins:[ThemesMixins],

    computed: {
        ...mapGetters({
            token:'auth/token',
        }),

    },
    methods: {
        ...mapActions({
            setSnakbar:'snakbar/setSnakbar'
        }),
        eventChange(event){
            const files = event.target.files
             this.foto = files[0]
              const fileReader = new FileReader()
             fileReader.addEventListener('load',()=>{
                 this.imgurl=fileReader.result
             })
              fileReader.readAsDataURL(this.foto)
        },
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
              evt.preventDefault();
            } else {
              return true;
            }
        },
        formatAsCurrency (value = 0 , dec) {
            dec = dec || 0
            if (value === null) {
                return null
            }
            return '' + value.toFixed(dec).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
        },
    },

    created(){
        this.config = {
            headers: {
                'Authorization': 'Bearer ' + this.token,
            }
        }
    },
    components:{

    }
}
